<div class="spinner-wrap" *ngIf="state.showSpinner">
  <rt-spinner variant="small"></rt-spinner>
</div>

<div *ngIf="!state.showSpinner">
  <rt-icon name="check" size="medium"> </rt-icon>
  <rt-icon name="dot" size="small-x"> </rt-icon>
</div>
